export default "__VITE_ASSET__NiCWaEuG__"